import React from 'react';
import { SnapDialog, Button } from '@one-snap/sparkles';
import PropTypes from 'prop-types';
import './AwarenessPageStyles.css';
import Footbar from './Footbar';
import CartAmountHeader from './CartAmountHeader';

function AwarenessPage({
  isVisible,
  onClose,
  totalAmount,
  goBack,
  onContinue
}) {
  return (
    <SnapDialog open={isVisible} onClose={onClose}>
      <div className="awareness-page">
        <CartAmountHeader
          totalAmount={totalAmount}
          goBack={goBack}
          showCartAmount
        />
        <div className="awareness-content">
          <img
            src="/like-with-shadow.png"
            alt="like with a shadow"
            className="lto-align-success-center"
          />
          <div className="awareness-title">
            You are applying for lease-to-own financing
          </div>
          <br />
          <div className="awareness-section">
            <div className="section-title">What Is Lease-to-Own Financing?</div>
            <div className="section-content">
              Lease-to-own is an alternative method of financing. Snap buys the
              merchandise and leases it to you. Once you&apos;ve fulfilled the
              terms of your agreement, the merchandise is yours.
            </div>
          </div>
          <div className="awareness-section">
            <div className="section-title">
              Standard Lease Costs and Payments
            </div>
            <div className="section-content">
              <ul>
                <li>Lease-to-own terms renew for a maximum of 12-18 months.</li>
                <li>
                  The lease includes a Cost of Lease added to the cash price of
                  the merchandise being leased. Your total cost will usually be
                  more than double the cash price of the merchandise if you do
                  not exercise one of our early purchase options.
                </li>
                <li>
                  Your lease payments will be automatically deducted from the
                  checking account provided in the lease application.
                </li>
              </ul>
            </div>
          </div>
          <div className="awareness-section">
            <div className="section-title">You Have Options with Snap</div>
            <div className="section-content">
              <ul>
                <li>
                  You have options to gain ownership early and save on lease
                  costs.
                </li>
                <li>
                  You may cancel your lease at any time by notifying and
                  returning the merchandise to Snap.
                </li>
              </ul>
            </div>
          </div>
          <Button onClick={onContinue} className="continue-button">
            Continue
          </Button>
          <Footbar />
        </div>
      </div>
    </SnapDialog>
  );
}

AwarenessPage.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  totalAmount: PropTypes.string.isRequired
};

export default AwarenessPage;
